import React, { useEffect, useState } from 'react'
import { Statistic } from 'antd'
import { getSelectedLanguageContent, handleNestedObjectKey } from 'utils'
import moment from 'moment';

const { Countdown } = Statistic;

const TechBaseStatistic = props => {
  let {
    title,
    value,
    prefix,
    suffix,
    valueDataKey,
    prefixDataKey,
    suffixDataKey,
    valueStyle,
    style,
    variant,
    format
  } = props.item

  const [ isCurrent, setIsCurrent ] = useState( false)

  useEffect(() => {
    if( variant === 'countdown' ) {
      setIsCurrent( moment( value ) - moment() > 0 )
    }
  }, [ value ])

  const getSuffix = ( suffix, suffixDataKey, props ) => {
    if( suffixDataKey ) {
      const data = handleNestedObjectKey( props, suffixDataKey )
      if( suffix ) {
        return suffix.replaceAll( '${PLACEHOLDER}', data )
      }
      return `/ ${ data }`
    } else {
      return suffix
    }
  }

  return(
    <>
      {
        variant === 'statistic' && (<Statistic
          title={ getSelectedLanguageContent( title, props.selectedLanguage )}
          value={ value || handleNestedObjectKey( props, valueDataKey )}
          prefix={ prefix || handleNestedObjectKey( props, prefixDataKey )}
          suffix={ getSuffix( suffix, suffixDataKey, props )}
          valueStyle={ valueStyle }
          style={ style }
        />)
      }
      {
        variant === 'countdown' && (<Countdown
          title={ title }
          value={ value || ( valueDataKey && handleNestedObjectKey( props, valueDataKey ))}
          format={ format || 'D[d] H[H] m[M] s[S]'}
          valueStyle={ valueStyle || { color: isCurrent ? '#56B533' : 'red'}}
        />)
      }
    </>
  )
}

export default TechBaseStatistic
